export const AboutUsContents = [
  {
    title: "Study",
    imgUrl: "Aboutus1.png",
    description:
      "Study Session을 통해 데이터 분석과 인공지능에 대한 깊이 있는 이해를 추구하고 실무를 위한 이론적 기반을 다집니다.",
  },
  {
    title: "Project",
    imgUrl: "Aboutus2.png",
    description:
      "Project Session을 통해 팀을 구성해 실제 대회나 공모전에 참가하면서 협동심을 기르고 성장할 수 있는 경험을 하게 됩니다.",
  },
  {
    title: "Network",
    imgUrl: "Aboutus3.png",
    description:
      "현업 및 대학원에 종사하고 있는 Alumni 회원들과 지속적인 네트워크를 형성하고 있습니다. 유사한 분야의 학회들과의 교류를 통해 학술의 장을 확장해나가고 있습니다.",
  },
];

export const ActivitiesContents = [
  {
    title: "Special Lectures",
    imgUrl: "Activities1.png",
    description:
      "KUBIG은 현업에서 경험을 쌓으신 OB선배님들과 학계에서 활발히 연구하시는 교수님들을 초청하여 다양한 주제에 대한 세션을 진행하고 있습니다.",
  },
  {
    title: "Industry-academic Cooperation",
    imgUrl: "Activities2.png",
    description:
      "학회 내부 프로젝트에서 더 나아가, 실제 기업 및 교내 기관과 긴밀히 협업하여 기업이 고민하는 문제에 솔루션을 제시하거나 국가 과제를 수행하고 있습니다.",
  },
];

export const CurriculumContents = [
  {
    imgUrl: "CurImage1.png",
    semester: "방학 중",
    session: "Basic Session",
    sessionDescription:
      "학회 내부 세션을 개설하여 데이터 분석에 대해 수리적으로 이해하고 인공지능에 대한 기초를 쌓습니다.",
    project: "KUBIG Contest",
    projectDescription:
      "분반스터디의 연장으로 소규모 팀별 프로젝트를 진행하여 실제 데이터에 모델을 활용해보는 경험을 제공합니다.",
  },
  {
    imgUrl: "CurImage2.png",
    semester: "학기 중",
    session: "Advanced Session",
    sessionDescription:
      "관심분야가 비슷한 학회원들이 자유롭게 이론을 공부하고 코드 실습을 진행합니다.",
    project: "KUBIG Conference",
    projectDescription:
      "관심분야가 비슷한 학회원들이 하나의 프로젝트 주제를 선정해 문제의 솔루션을 제시합니다.",
  },
];
